import Divider from '@material-ui/core/Divider'
import React from 'react'
import { FieldProps } from 'react-jsonschema-form'

import { Body } from '../../utils/typography'

const TitleField = ({ title }: FieldProps) => {
  if (!title) return null

  return (
    <>
      <Body>{title}</Body>
      <Divider />
    </>
  )
}

export default TitleField
